module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("Территория обслуживания.")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('columns', [_c('column', {
    attrs: {
      "size": "10"
    }
  }, [_c('heading', [_vm._v("В настоящее время ООО «АРК-Энергосбыт» работает над проектами в 27 регионах Российской Федерации:")])], 1)], 1), _vm._v(" "), _c('columns', _vm._l((_vm.allRegions), function(regions, index) {
    return _c('column', {
      key: index,
      attrs: {
        "size": "4"
      }
    }, _vm._l((regions), function(region) {
      return _c('p', {
        key: region
      }, [_vm._v(_vm._s(region))])
    }))
  }))], 1), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('aside-image', {
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1240fe7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Regions.vue
// module id = 121
// module chunks = 0